import { render, staticRenderFns } from "./TypeMlValidationLabel.vue?vue&type=template&id=dfab13f6"
import script from "./TypeMlValidationLabel.vue?vue&type=script&lang=js"
export * from "./TypeMlValidationLabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports